<script lang="ts">
    import FieldHeading from './field-heading.svelte'
    import {
        computeImc,
        classifyImc,
        formatBRNumber,
        parseBRNumber,
        type ImcCalculatorValue,
    } from '../../types/imc-calculator'

    export let label: string
    export let data: Record<string, any>
    export let value: ImcCalculatorValue | null = null
    export let required = false
    export let readOnly = false

    let pesoText = formatBRNumber(value?.pesoKg ?? null)
    let alturaText = formatBRNumber(value?.alturaCm ?? null, 0)

    $: pesoKg = parseBRNumber(pesoText)
    $: alturaCm = parseBRNumber(alturaText)
    $: value = { pesoKg, alturaCm }

    $: imc = computeImc(pesoKg, alturaCm)
    $: classification = imc !== null ? classifyImc(imc) : null
    $: imcText = imc !== null ? formatBRNumber(imc, 1) : '-'
    $: tipoText = classification?.tipo ?? '-'
    $: riscoText = classification?.risco ?? '-'
</script>

<div class="view-field">
    <FieldHeading {label} {required} {readOnly} />
    <div class="imc-inputs-row">
        <div class="imc-field">
            <span class="imc-field-label">Peso</span>
            <div class="imc-input-wrap">
                <input type="text" inputmode="decimal" class="imc-input" bind:value={pesoText} disabled={readOnly} placeholder="0,00" />
                <span class="imc-unit">kg</span>
            </div>
        </div>
        <div class="imc-field">
            <span class="imc-field-label">Altura</span>
            <div class="imc-input-wrap">
                <input type="text" inputmode="decimal" class="imc-input" bind:value={alturaText} disabled={readOnly} placeholder="0" />
                <span class="imc-unit">cm</span>
            </div>
        </div>
    </div>
    <div class="imc-results-row imc-results-highlight">
        <div class="imc-result">
            <span class="imc-result-label">IMC:</span>
            <span class="imc-computed-value">{imcText}</span>
        </div>
        <div class="imc-result">
            <span class="imc-result-label">Tipo de obesidade:</span>
            <span class="imc-computed-value">{tipoText}</span>
        </div>
        <div class="imc-result">
            <span class="imc-result-label">Grau de risco:</span>
            <span class="imc-computed-value">{riscoText}</span>
        </div>
    </div>
</div>

<style>
    .view-field {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .imc-inputs-row,
    .imc-results-row {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(max(160px, calc((100% - 56px) / 3)), 1fr));
        gap: 10px 28px;
    }
    .imc-results-row {
        margin-top: 14px;
    }
    .imc-results-highlight {
        background-color: var(--cs2-accent-hover, #17be5e);
        padding: 4px;
        border-radius: 8px;
    }
    .imc-field {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
    }
    .imc-field-label {
        width: 50px;
        flex-shrink: 0;
        font-size: 0.88rem;
        color: #495057;
    }
    .imc-input-wrap {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
        min-width: 0;
    }
    .imc-input {
        flex: 1;
        min-width: 0;
        border: none;
        border-bottom: 1px solid #ced4da;
        background: transparent;
        padding: 6px 2px;
        font-size: 0.9rem;
        text-align: right;
    }
    .imc-input:focus {
        outline: none;
        border-bottom: 2px solid var(--cs2-accent, #1bdf6f);
    }
    .imc-input:disabled {
        background: transparent !important;
        color: #868e96;
        cursor: not-allowed;
    }
    .imc-unit {
        font-size: 0.82rem;
        color: #868e96;
        width: 24px;
    }
    .imc-result {
        display: flex;
        flex-direction: column;
        gap: 2px;
        min-width: 0;
    }
    .imc-result-label {
        font-size: 0.88rem;
        color: #495057;
    }
    .imc-computed-value {
        font-weight: 600;
        color: #212529;
    }
</style>
